import AggregateRatingTrustpilot from './AggregateRatingTrustpilot';

export default AggregateRatingTrustpilot;
